module.exports = __webpack_public_path__ + "static/media/inline.5c52fa6d.png";